<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>产品管理</BreadcrumbItem>
        <BreadcrumbItem>产品规格列表</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '580px', background: '#fff'}">
        <div style="height:50px;">
          <div style="float:left">
            <Button type="primary" @click="addArticle()">添加规格</Button>
          </div>
          <div style="float:right;">
            <Button  icon="ios-search" style="float:right;margin-left:5px;" @click="getpage()">Search</Button>
            <Input v-model="search" style="float:right;width:250px;"></Input>
          </div>
        </div>

        <div>
          <Table border ref="selection" :columns="columns7" :data="data"></Table><br>
          <span style="align:center" >
            <span v-if = "$route.query.page == undefined ">
              <Page :total="page" :page-size="10" :current="1"  @on-change="getpage" ></Page>
            </span>
            <span v-else>
              <Page :total="page" :page-size="10" :current="parseInt($route.query.page)"  @on-change="getpage" ></Page>
            </span>
          </span>
        </div>
        <!-- 弹出框代码start -->
        <Modal
            v-model="modal1"
            @on-ok="ok"
            @on-cancel="cancel">
            <p>是否删除这个规格？</p>
        </Modal>
        <!-- 弹出框代码end -->

        <!-- 弹出框代码start -->
        <Modal v-model="addbrand" @on-ok="ok_addbrand" @on-cancel="cancel_addbrand" title="添加规格">
            <div class="modeldiv">
              <p class="catename"><b>规格名称</b></p>
              <Input  placeholder="请输入规格名称" style="width: 300px" v-model="spec_name"></Input><br><br>
              <p class="catename"><b>所属模型</b></p>
              <Select v-model="modelid" style="width:300px">
                  <Option v-for="item in modellist" :value="item.id" :key="item.id" >{{ item.name }}</Option>
              </Select><br><br>
              <p class="catename"><b>规格属性名称</b>&nbsp;&nbsp;&nbsp;
              <Icon type="md-add" @click="attr_array.push({id:'',attr_name:''})" />
              </p>
              <div v-for="(item, index) in attr_array" :key='index'>
                <Input v-model="item.attr_name" type="text" placeholder="请输入规格属性" style="width: 300px"/>&nbsp;&nbsp;&nbsp;
                <Icon type="md-trash" @click="attr_array.splice(index,1)" />
              </div>

            </div>
        </Modal>
        <!-- 弹出框代码end -->
    </Content>
  </div>
</template>
<style scoped>
.info {
  border-radius: 10px;
  line-height: 20px;
  padding: 10px;
  margin: 10px;
  background-color: #ffffff;
}
</style>
<script>
import productspec from '@/assets/js/views/product/productspec';

export default {
  ...productspec,
};
</script>

